import { render, staticRenderFns } from "./TotaleFatturati.vue?vue&type=template&id=45c198b1&scoped=true"
import script from "./TotaleFatturati.vue?vue&type=script&lang=js"
export * from "./TotaleFatturati.vue?vue&type=script&lang=js"
import style0 from "./TotaleFatturati.vue?vue&type=style&index=0&id=45c198b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c198b1",
  null
  
)

export default component.exports